import { GridColDef } from '@mui/x-data-grid';
import { Chip, Button } from '@mui/material';

export const getRefundRequestColumns = (
  onViewDetails: (id: number) => void,
  onApprove: (id: number) => void,
  onReject: (id: number) => void
): GridColDef[] => [
  {
    field: 'id',
    headerName: 'ID',
    width: 80,
    type: 'number'
  },
  {
    field: 'userId',
    headerName: 'User ID',
    width: 90,
    type: 'number'
  },
  {
    field: 'userName',
    headerName: 'User Name',
    width: 150,
    valueGetter: (value: any, row: any) => row.user?.name || row.user?.email || 'N/A'
  },
  {
    field: 'paymentIntentId',
    headerName: 'Payment Intent',
    width: 200
  },
  {
    field: 'itemType',
    headerName: 'Item Type',
    width: 140,
    valueGetter: (value: any, row: any) => {
      const typeMap: { [key: string]: string } = {
        adSpace: 'Ad Space',
        tokenPlan: 'Token Plan',
        subscriptionPlan: 'Subscription Plan',
        purchasePlan: 'Purchase Plan'
      };
      return typeMap[row.itemType] || row.itemType;
    }
  },
  {
    field: 'itemName',
    headerName: 'Item Name',
    width: 200,
    valueGetter: (value: any, row: any) => row.itemDetails?.itemName || 'N/A'
  },
  {
    field: 'refundAmount',
    headerName: 'Refund Amount',
    width: 140,
    type: 'number',
    valueGetter: (value: any, row: any) => {
      const amount = parseFloat(row.refundAmount);
      const currency = row.itemDetails?.currencyCode || 'USD';
      return `$${amount.toFixed(2)} ${currency}`;
    }
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 120,
    renderCell: (params) => {
      const colorMap: { [key: string]: 'warning' | 'info' | 'success' | 'error' } = {
        pending: 'warning',
        approved: 'info',
        processed: 'success',
        rejected: 'error',
        failed: 'error'
      };
      return (
        <Chip
          label={params.row.status}
          color={colorMap[params.row.status] || 'default'}
          size="small"
        />
      );
    }
  },
  {
    field: 'created_at',
    headerName: 'Request Date',
    width: 160,
    valueGetter: (value: any, row: any) => {
      return row.created_at
        ? new Date(row.created_at).toLocaleString()
        : 'N/A';
    }
  },
  {
    field: 'reviewedBy',
    headerName: 'Reviewed By',
    width: 130,
    valueGetter: (value: any, row: any) => row.reviewer?.name || row.reviewer?.email || (row.reviewedBy ? `ID: ${row.reviewedBy}` : 'N/A')
  },
  {
    field: 'reviewedAt',
    headerName: 'Reviewed Date',
    width: 160,
    valueGetter: (value: any, row: any) => {
      return row.reviewedAt
        ? new Date(row.reviewedAt).toLocaleString()
        : 'N/A';
    }
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 280,
    sortable: false,
    renderCell: (params) => {
      const isPending = params.row.status === 'pending';
      return (
        <div style={{ display: 'flex', gap: '8px' }}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => onViewDetails(params.row.id)}
          >
            View
          </Button>
          {isPending && (
            <>
              <Button
                variant="contained"
                color="success"
                size="small"
                onClick={() => onApprove(params.row.id)}
              >
                Approve
              </Button>
              <Button
                variant="contained"
                color="error"
                size="small"
                onClick={() => onReject(params.row.id)}
              >
                Reject
              </Button>
            </>
          )}
        </div>
      );
    }
  }
];
